import { render, staticRenderFns } from "./OtherLabourDetail.vue?vue&type=template&id=5234eed6&scoped=true"
import script from "./OtherLabourDetail.vue?vue&type=script&lang=js"
export * from "./OtherLabourDetail.vue?vue&type=script&lang=js"
import style0 from "./OtherLabourDetail.vue?vue&type=style&index=0&id=5234eed6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5234eed6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5234eed6')) {
      api.createRecord('5234eed6', component.options)
    } else {
      api.reload('5234eed6', component.options)
    }
    module.hot.accept("./OtherLabourDetail.vue?vue&type=template&id=5234eed6&scoped=true", function () {
      api.rerender('5234eed6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/otherlabour/OtherLabourDetail.vue"
export default component.exports